import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type { CatalogChangeRequestPayload, CatalogOptions } from '../types/waste-catalog.type';

function unwrap<T>(response: unknown): T {
  if (response && typeof response === 'object' && 'result' in response) {
    return (response as { result: T }).result;
  }
  return response as T;
}

export async function getCatalogOptions(
  context: 'market' | 'pre_order',
  organizationId?: string,
  collectionSiteId?: string,
): Promise<CatalogOptions> {
  const response = await makeRequest({
    url: '/waste-catalog/options',
    method: HttpMethods.GET,
    params: {
      context,
      organization_id: organizationId,
      collection_site_id: collectionSiteId,
    },
  });
  return unwrap<CatalogOptions>(response);
}

export async function createCatalogChangeRequest(payload: CatalogChangeRequestPayload) {
  const response = await makeRequest({
    url: '/waste-catalog/change-requests',
    method: HttpMethods.POST,
    data: payload,
  });
  return unwrap(response);
}
